const errorField = (obj) => {
	let result = {};
	if (obj) result = { [obj.field]: true };
	return result;
};

export { errorField };
